import { toast } from 'react-toastify'
import {
  getArticleById,
  getCourseData,
  getFeatureItemBySlug,
  getFeatureList,
  getMentalStateTypeById,
  getMentalStateTypeList,
  getQuoteData,
  getRestDataById,
} from 'src/consumer/services/featureServices'
import { getDataWithParams } from 'src/consumer/services/profileService'
import { isCommonResponseSuccessful } from 'src/mentor/helpers/utilityFunctions'
import { getMPData, getMPDataWithParams, postMPDataWithParams } from 'src/mentor/services'
import { getSingleTechnique } from '../MentorProfilePage/utils'

export function checkIfStringIsValid(str) {
  if (typeof str !== 'string') {
    return false
  }
  return str.length > 0
}

export function isValidNumber(value) {
  return typeof value === 'number' && Number.isFinite(value)
}

export function isValidInteger(value) {
  return isValidNumber(value) && Number.isInteger(value)
}

export function categoryToDailyPlayType(category, store) {
  const catMap = {
    myQuotes: 'quote',
    myBreathe: 'breathe',
    myJournal: 'journal',
    myPractices: 'practice',
    'mental-state-type': 'mental-state-type',
    assessment: 'assessment',
  }
  const featuredCats = store.metaCategories.filter((c) => c.categoryType !== 'course')
  const filteredCategories = featuredCats.filter((c) => !catMap?.[c.id])
  const finalCategories = filteredCategories.reduce((newCatMap, category) => {
    return { ...newCatMap, [category.id]: category.id }
  }, catMap)
  return finalCategories?.[category] || 'course'
}

export const PHASE_OBJECT = {
  id: '',
  entityItemType: '',
  enabled: true,
  deleted: false,
  idByUser: false,
  slug: '',
  colors: null,
  apiParam: 'plan-phase',
  title: '',
  description: '',
  why: '',
  impact: '',
  firstDay: '',
  lastDay: '',
}

export const ACTIVITY_OBJECT = {
  id: '',
  entityItemType: '',
  enabled: true,
  deleted: false,
  idByUser: false,
  slug: '',
  colors: null,
  apiParam: 'activity',
  descriptionSentence: '',
  descriptionZ: '',
  descriptionW: '',
  customDescription: '',
  metaCategoryId: '',
  customCategoryTitle: '',
  internalNote: '',
  activityId: '',
  activityTitle: '',
  whatItDoes: '',
  whyOffered: '',
}

export const PLANNED_ACTIVITY_OBJECT = {
  id: '',
  createdBy: '',
  entityItemType: '',
  enabled: true,
  deleted: false,
  idByUser: false,
  slug: '',
  colors: null,
  apiParam: 'planned-activity',
  modifiedBy: '',
  plannedActivityId: '',
  otherActivityIds: [],
  planId: '',
  plannedActivity: null,
  otherActivities: [ACTIVITY_OBJECT],
}

export const ACTIVITY_PLAN_OBJECT = {
  id: '',
  entityItemType: '',
  enabled: true,
  deleted: false,
  idByUser: false,
  slug: '',
  colors: null,
  apiParam: 'activity-plan',
  title: '',
  description: '',
  subscriptionType: 'subscription_free',
  totalDays: 1,
  phaseIds: [],
  phaseList: [],
  // phaseList: [{ ...PHASE_OBJECT, days: 1, firstDay: 1, lastDay: 1, title: 'Phase 1' }],
  plannedActivity: null,
  plannedActivityIds: [],
  plannedActivities: [PLANNED_ACTIVITY_OBJECT],
  status: 'draft',
  visibility: 'public',
}

export async function getAllActivityPlans() {
  return []
}

export async function getSubscriptionLevels() {
  const resp = await getMPData('/api/secure/teacher/subscription-levels')
  if (resp.status === 200) {
    return resp.data
  } else {
    return []
  }
}

export async function saveCustomPlan() {}

export async function savePhases() {}

// async function getAndSetActivityTitle(card, category = 'meditation') {
//   let titleToReturn = card?.title
//   let extraItem
//   if (!card?.title && card?.itemId !== '') {
//     switch (card.type) {
//       case 'course':
//         const courseResponse = await getMPDataWithParams(
//           ONLINE_COURSES_APIS.onlineCourse.getMinimalSummaryList,
//           { sessionIds: card.itemId?.split(' : ')?.[0] },
//         )
//         const sessionId = card.itemId?.split(' : ')?.[0]
//         const courseId = card.itemId?.split(' : ')?.[1]
//         const foundCourseSessionsArray = courseResponse?.data
//         const foundCourse = foundCourseSessionsArray?.find((courseSess) => {
//           if (checkIfStringIsValid(courseId)) {
//             return courseSess?.sessionId === sessionId && courseSess?.courseId === courseId
//           } else {
//             return true
//           }
//         })
//         const teacherResponse = await getMPDataWithParams(GENERIC_APIS.entity.getPaginated, {
//           entityType: 'mentor',
//           ids: foundCourse?.createdFor,
//         })
//         console.log({ sessionId, courseId, foundCourseSessionsArray })
//         titleToReturn = `${teacherResponse?.data?.content?.[0]?.title} - ${foundCourse?.title}`
//         break
//       case 'quote':
//         const quoteResponse = await getMPDataWithParams(
//           FEATURES_API.quotes.getSingle.url + card.itemId,
//           {
//             quoteId: card.itemId,
//           },
//         )
//         if (quoteResponse.status === 200) {
//           titleToReturn = `${quoteResponse.data.author} - ${quoteResponse.data.msg}`
//           extraItem = quoteResponse.data
//         }
//         break
//       case 'breathe':
//         const breatheResponse = await getMPDataWithParams(FEATURES_API.breathe.getSingle.url, {
//           id: card.itemId,
//         })
//         if (breatheResponse.status === 200) {
//           const foundBreathe = breatheResponse.data
//           titleToReturn = foundBreathe?.name
//           extraItem = foundBreathe
//         }
//         break
//       case 'journal':
//         const journalResponse = await getMPDataWithParams(FEATURES_API.journals.getSingle.url, {
//           id: card.itemId,
//         })
//         if (journalResponse.status === 200) {
//           titleToReturn = `${journalResponse.data.title}`
//           extraItem = journalResponse.data
//         }
//         break
//       default:
//         const dataResponse = await getMPDataWithParams(GENERIC_APIS.entity.details, {
//           id: card.itemId,
//           entityType: card.type,
//         })
//         if (dataResponse.status === 200) {
//           const foundPractice = dataResponse.data
//           titleToReturn =
//             foundPractice?.title || foundPractice?.name || foundPractice?.internalTitle
//           extraItem = foundPractice
//         }
//         break
//     }
//   }
//   console.log({ extraItem })
//   return { ...card, title: titleToReturn, extraItem: extraItem || {} }
// }

function validateContent(content) {
  if (!content.contentItem) {
    return false
  }
  return true
}

export async function savePlanItems(rawContent) {
  const content = content.filter((cont) => !cont?._delete)
  const validated = content.reduce((acc, cont) => {
    if (!acc) {
      return acc
    }
    return validateContent(cont)
  }, true)
  if (!validated) {
    toast.error('One of the content items is in incorrect format!')
    return { validated: validated }
  }
}

export async function handleCustomPlanContentDropDown(
  selectedValue,
  tempCard,
  setTempCard,
  getReflection,
) {
  tempCard.type === 'quote' && getReflection(selectedValue.journalId)
  setTempCard((prev) => {
    const { value, label, sessionId, ...rest } = selectedValue
    return {
      ...prev,
      contentItem: selectedValue,
    }
  })
}

// export async function getActivityObject(activityId, categoryId, store) {
//   const convertedActivityIdObject = {
//     itemId: activityId,
//     type: categoryToDailyPlayType(categoryId, store),
//   }
//   const dpCardFoundObject = await getAndSetActivityTitle(convertedActivityIdObject)
//   console.log({ dpCardFoundObject })
//   return { value: activityId, label: dpCardFoundObject.title || activityId }
// }

export function fixStartDaysAndEndDays(phases) {
  let pStartDay = 1
  let toReturn = []
  for (let i = 0; i < phases?.length || 0; ++i) {
    toReturn.push({
      ...phases?.[i],
      firstDay: pStartDay,
      lastDay: pStartDay + (phases?.[i]?.days || 1) - 1,
    })
    pStartDay += phases?.[i]?.days || 1
  }
  return toReturn
}

// export async function getAndSetActivitiesInPlannedActivities(plannedActivities, store) {
//   const allActivities = plannedActivities.reduce((acc, pActivity) => {
//     const currentActivities = pActivity?.otherActivities?.map((activity) => ({
//       pActId: pActivity?.id,
//       value: activity?.activityId,
//       metaCategoryId: activity?.metaCategoryId,
//     }))
//     return [...acc, ...currentActivities]
//   }, [])
//   const setOfUniqueCategories = new Set(allActivities?.map((activity) => activity?.metaCategoryId))
//
//   console.log({ setOfUniqueCategories })
//
//   const allActivitiesWithTheirTitles = await Promise.all(
//     allActivities?.map(async (activity) => {
//       const response = await getActivityObject(activity?.value, activity?.metaCategoryId, store)
//       return { ...activity, ...response }
//     }),
//   )
//   console.log({ allActivitiesWithTheirTitles })
// }

export function fixDaysAndContent(plan, allPhases, plannedActivities) {
  const totalDays = allPhases[allPhases.length - 1].lastDay

  for (let phaseIndex = 0; phaseIndex < allPhases?.length || 0; phaseIndex++) {
    const currentPhase = allPhases[phaseIndex]
    const currentPlannedActivities = plannedActivities.filter(
      (activity, index) =>
        index + 1 >= (currentPhase?.firstDay || 0) && index + 1 <= (currentPhase?.lastDay || 0),
    )

    if (currentPlannedActivities?.length < currentPhase?.days) {
      for (
        let dayIndex = currentPhase?.firstDay || 0;
        dayIndex <= currentPhase?.lastDay || 0;
        dayIndex++
      ) {
        if (!currentPlannedActivities.find((activity, index) => index + 1 === dayIndex)) {
          plannedActivities.push({
            ...PLANNED_ACTIVITY_OBJECT,
            planId: plan.id || '',
          })
        }
      }
    } else {
      plannedActivities = plannedActivities.map((activity, index) => {
        const activityDay = index + 1
        return activityDay >= currentPhase.firstDay && activityDay <= currentPhase.lastDay
          ? { ...activity, _delete: false }
          : { ...activity, _delete: true }
      })
    }
  }

  return plannedActivities
}

export function filterContentBasedOnPhsCondition(contentDay, phase) {
  return contentDay < phase?.lastDay && contentDay >= phase?.firstDay
}

export function formatBeforeSavingActivityPlan(activityPlan) {}

export function validateActivityPlan(activityPlan) {
  let validationPoints = {
    title: { valid: true, message: '' },
    phases: { valid: true, message: '' },
    plannedActivities: Array.from(
      { length: activityPlan?.plannedActivities?.length - activityPlan?.totalDays },
      (_, index) => ({ valid: true, message: '' }),
    ),
  }

  ///VALIDATION PHASES
  if (!checkIfStringIsValid(activityPlan?.title)) {
    validationPoints.title.valid = false
    validationPoints.title.message = 'Activity Plan Title cannot be empty.'
  }
  const phaseValidity = checkPhasesValidity(activityPlan)
  validationPoints = { ...validationPoints, phases: phaseValidity }
  validationPoints = {
    ...validationPoints,
    plannedActivities: activityPlan?.plannedActivities
      ?.filter((pAct, idx) => idx < activityPlan?.totalDays)
      .map((plannedActivity, idx) => {
        const allValid = plannedActivity.otherActivities.some((activity) => {
          return (
            checkIfStringIsValid(activity.metaCategoryId) &&
            checkIfStringIsValid(activity.customCategoryTitle) &&
            checkIfStringIsValid(activity.activityTitle) &&
            checkIfStringIsValid(activity.descriptionW) &&
            checkIfStringIsValid(activity.descriptionZ)
          )
        })
        if (!allValid) {
          return {
            valid: false,
            message: `Day ${idx + 1}`,
          }
        } else {
          return {
            valid: true,
            message: '',
          }
        }
      }),
  }
  return validationPoints
  /////////
}

export async function formSavableActivityPlan(activityPlan, mentorId, loadingTst) {
  let activityPlanToUse = activityPlan
  activityPlanToUse = {
    ...activityPlan,
    phaseList: activityPlan.phaseList.map((phase) => {
      const { days, ...restPhase } = phase
      return restPhase
    }),
  }
  const plannedActivitiesToUse = activityPlanToUse.plannedActivities?.filter((pAct, idx) => {
    return idx < activityPlan?.totalDays
  })
  let plannedActivitiesWithSavedActivities = await Promise.all(
    plannedActivitiesToUse.map(async (plannedActivity) => {
      const formedPlannedActivity = await getPlannedActivityWithSavedActivities(
        plannedActivity,
        mentorId,
        loadingTst,
      )
      return formedPlannedActivity
    }),
  )
  // plannedActivitiesWithSavedActivities = await Promise.all(
  //   plannedActivitiesWithSavedActivities.map(async (plannedActivity) => {
  //     const savedPlannedActivityResponse = await SaveEntity(
  //       'planned-activity',
  //       {
  //         ...plannedActivity,
  //         planId: activityPlanToUse.id,
  //       },
  //       undefined,
  //       undefined,
  //       undefined,
  //       false,
  //     )
  //     if (savedPlannedActivityResponse.status === 200) {
  //       return savedPlannedActivityResponse.data
  //     }
  //   }),
  // )
  //
  // let savedPhases = await Promise.all(
  //   activityPlanToUse.phaseList.map(async (phase) => {
  //     const { _newPhase, ...phaseToUse } = phase
  //
  //     const savedPhaseResponse = await SaveEntity(
  //       'plan-phase',
  //       phaseToUse,
  //       undefined,
  //       undefined,
  //       undefined,
  //       false,
  //     )
  //     if (savedPhaseResponse.status === 200) {
  //       return savedPhaseResponse.data
  //     }
  //   }),
  // )

  return {
    ...activityPlanToUse,
    // phaseList: savedPhases,
    // phaseIds: savedPhases.map((phase) => phase.id),
    plannedActivities: plannedActivitiesWithSavedActivities,
    // plannedActivityIds: plannedActivitiesWithSavedActivities.map(
    //   (plannedActivity) => plannedActivity.id,
    // ),
  }
}

async function getPlannedActivityWithSavedActivities(plannedActivity, mentorId, loadingTst) {
  const savedPlannedActivities = await Promise.all(
    plannedActivity.otherActivities.map(async (otherActivity) => {
      const activityToUse = {
        ...otherActivity,
        activityId:
          typeof otherActivity.activityId === 'string'
            ? { value: otherActivity.activityId }
            : otherActivity.activityId,
      }
      const { _newActivity, ...cleanedActivity } = activityToUse
      if (
        checkIfStringIsValid(cleanedActivity.metaCategoryId) &&
        checkIfStringIsValid(cleanedActivity.customCategoryTitle) &&
        checkIfStringIsValid(cleanedActivity.activityTitle) &&
        checkIfStringIsValid(cleanedActivity.descriptionW) &&
        checkIfStringIsValid(cleanedActivity.descriptionZ)
      ) {
        const activityToUse = {
          ...cleanedActivity,
          activityId: cleanedActivity?.activityId?.value,
          mentorId: mentorId,
        }
        const savedActivityResponse = await postMPDataWithParams(
          '/api/secure/teacher/activity',
          activityToUse,
          {},
          loadingTst,
        )
        if (
          savedActivityResponse.status === 200 &&
          isCommonResponseSuccessful(savedActivityResponse?.data?.code)
        ) {
          return savedActivityResponse.data.data.activity
        }
      } else {
        return { ...cleanedActivity, activityId: cleanedActivity.activityId?.value }
      }
    }),
  )
  const mainActivity = savedPlannedActivities?.[0]
  const actualOtherActivities = savedPlannedActivities?.slice(1) || []
  return {
    ...plannedActivity,
    plannedActivity: mainActivity,
    otherActivities: actualOtherActivities,
    otherActivityIds: actualOtherActivities.map((activity) => activity.id),
    plannedActivityId: mainActivity.id,
  }
}

export function checkPhasesValidity(activityPlan) {
  if (
    activityPlan?.phaseList?.[activityPlan?.phaseList?.length - 1]?.lastDay >
    activityPlan?.totalDays
  ) {
    return {
      valid: false,
      message: 'The last day of the last phase is exceeding the total number of days of the plan.',
    }
  } else {
    if (
      activityPlan?.phaseList?.[activityPlan?.phaseList?.length - 1]?.lastDay <
      activityPlan?.totalDays
    ) {
      return {
        valid: false,
        message:
          'The the days in the phases are not adding up to the total number of days of the plan.',
      }
    }
    return {
      valid: true,
      message: '',
    }
  }
}

export async function getSingleActivityPlan(activityPlanId, mentorId) {
  const response = await getMPDataWithParams('/api/secure/teacher/activity-plans/summary', {
    planIds: activityPlanId,
    mentorId: mentorId,
    summaryOnly: false,
  })
  if (response.status === 200) {
    return response.data?.[0]
  }
}

export async function searchCourseEpisodes(search, allOptionsObject) {
  return {
    ...allOptionsObject,
    content: allOptionsObject.content?.filter((course) =>
      `${course?.course.createdForName} - ${course?.episode.title}`
        .toLowerCase()
        .includes(search?.toLowerCase()),
    ),
  }
}

export async function getOptions(
  type,
  category,
  contentlanguages,
  pageSize,
  currentPage,
  search,
  useCourseIdWithSessionId = false,
  mentorIds,
  typeOfData = 'open',
) {
  const languages = contentlanguages
  const params = {
    languages: languages.join(','),
    size: pageSize,
    page: currentPage,
    search: search,
    includeDisabled: false,
    searchType: typeOfData,
  }
  let toReturn = []
  console.log({ type })
  switch (type) {
    case 'course':
      const courseResponse = await getCourseResponse(
        params.page,
        params.size,
        params.search,
        category,
        languages.join(','),
      )
      if (courseResponse.status === 200) {
        toReturn = {
          ...courseResponse.data,
          content: courseResponse.data.content
            // ?.filter((course) =>
            //   search !== ''
            //     ? course?.episode.title.toLowerCase().includes(search?.toLowerCase())
            //     : true,
            // )
            ?.map((course) => {
              return {
                ...course,
                value: course?.id,
                label: `${course.createdForName} - ${course?.title}`,
              }
            }),
        }
        console.log({ toReturn })
      }
      break
    case 'breathe':
      const breatheResponse = await getBreathingTechniques(
        params.page,
        params.size,
        params.search,
        category,
        languages.join(','),
      )
      if (breatheResponse.status === 200) {
        toReturn = {
          ...breatheResponse.data,
          content: breatheResponse.data?.content?.map((breathe) => {
            return {
              ...breathe,
              value: breathe.id,
              label: breathe.name,
              subscriptionId: breathe.subscription?.id,
            }
          }),
          last: true,
          number: breatheResponse.data?.length,
          pageable: { pageSize: breatheResponse.data?.length },
        }
      }
      break
    case 'quote':
      const quoteResponse = await getQuotes(
        params.page,
        params.size,
        params.search,
        category,
        languages.join(','),
      )
      if (quoteResponse.status === 200) {
        console.log('inside options')
        toReturn = {
          ...quoteResponse?.data,
          content: quoteResponse?.data.content?.map((quote) => {
            return {
              ...quote,
              value: quote?.id,
              label: `${quote?.author || 'Unknown'} - ${quote?.msg}`,
              subscriptionId: 'subscription_basic',
            }
          }),
        }
      }
      break
    case 'journal':
      const journalResponse = await getJournals(
        params.page,
        params.size,
        params.search,
        category,
        languages.join(','),
      )
      if (journalResponse.status === 200) {
        toReturn = {
          ...journalResponse.data,
          content: journalResponse.data.content.map((journal) => {
            return {
              ...journal,
              value: journal.id,
              label: `${journal.title || 'No Title'}`,
              subscriptionId: journal.subscription?.id,
            }
          }),
        }
      }
      break
    case 'practice':
      const practiceResponse = await getPractices(
        params.page,
        params.size,
        params.search,
        category,
        languages.join(','),
      )
      if (practiceResponse.status === 200) {
        toReturn = {
          ...practiceResponse.data,
          content: practiceResponse.data.content?.map((practice) => {
            return {
              ...practice,
              value: practice?.id,
              label: practice?.title,
              subscriptionId: practice?.subscription?.id,
            }
          }),
        }
      }
      break
    case 'assessment':
      const assessmentResp = await getAssessments(
        params.page,
        params.size,
        params.search,
        category,
        languages.join(','),
      )
      toReturn = {
        ...assessmentResp,
        content: assessmentResp.content?.map((practice) => {
          return {
            ...practice,
            value: practice?.id,
            label: practice?.title,
            subscriptionId: practice?.subscription?.id,
          }
        }),
      }
      break
    case 'article':
      const articleResponse = await getArticles(
        params.page,
        params.size,
        params.search,
        category,
        languages.join(','),
      )
      toReturn = {
        ...articleResponse,
        content: articleResponse.content?.map((practice) => {
          return {
            ...practice,
            value: practice?.id,
            label: practice?.title,
            subscriptionId: practice?.subscription?.id,
          }
        }),
      }
      break
    case 'technique':
      const techniqueResponse = await getTechniques(
        params.page,
        params.size,
        params.search,
        category,
        languages.join(','),
      )
      toReturn = {
        ...techniqueResponse,
        content: techniqueResponse.content.map((technique) => ({
          ...technique,
          value: technique.id,
          label: technique.name || technique.title,
        })),
      }
      break
    case 'rest':
      const restResponse = await GetRestData(
        params.page,
        params.size,
        params.search,
        category,
        languages.join(','),
        mentorIds,
        params.searchType,
      )
      toReturn = {
        ...restResponse,
        content: restResponse.content.map((restItem) => ({
          ...restItem,
          value: restItem.id,
          label: restItem.name || restItem.title,
        })),
      }
      break
    case 'mental-state-type':
      const mentalStateTypes = await getMentalStateTypes(
        params.page,
        params.size,
        params.search,
        category,
        languages.join(','),
      )
      toReturn = {
        ...mentalStateTypes,
        content: mentalStateTypes.content.map((mentalStateTypeItem) => ({
          ...mentalStateTypeItem,
          value: mentalStateTypeItem.id,
          label: mentalStateTypeItem.name || mentalStateTypeItem.title,
        })),
      }
      break
    default:
      toReturn = {
        content: [],
        last: true,
      }
      break
  }
  console.log({ toReturn })
  return toReturn
}

export async function getCourseResponse(page, pageSize, search, category, languages) {
  const courseResponse = await getDataWithParams('/api/secure/teacher/search/courses', {
    page: page,
    size: pageSize,
    search: search,
    category,
    contentLanguages: languages,
  })
  if (courseResponse.status === 200) {
    return courseResponse
  } else {
    toast.error('Something went wrong')
  }
}

export async function getBreathingTechniques(page, pageSize, search, category, languages) {
  const breatheResponse = await getDataWithParams('/api/secure/teacher/search/breathworks', {
    page: page,
    size: pageSize,
    search: search,
    category,
    //NO language code in api
  })
  if (breatheResponse.status === 200) {
    return breatheResponse
  } else {
    toast.error('Something went wrong')
  }
}

export async function getQuotes(page, pageSize, search, category, languages) {
  const quoteResponse = await getDataWithParams('/api/secure/teacher/search/quotes', {
    page: page,
    size: pageSize,
    search: search,
    category,
  })
  if (quoteResponse.status === 200) {
    return quoteResponse
  } else {
    toast.error('Something went wrong')
  }
}

export async function getJournals(page, pageSize, search, category, languages) {
  const journalResponse = await getDataWithParams('/api/secure/teacher/search/journals', {
    page: page,
    size: pageSize,
    search: search,
    category,
  })
  // const journalResponse = await getFeatureList('journal', page)
  if (journalResponse.status === 200) {
    return journalResponse
  } else {
    toast.error('Something went wrong')
  }
}

export async function getPractices(page, pageSize, search, category, languages) {
  const breatheResponse = await getDataWithParams('/api/secure/teacher/search/practices', {
    page: page,
    size: pageSize,
    search: search,
    category,
  })
  if (breatheResponse.status === 200) {
    return breatheResponse
  } else {
    toast.error('Something went wrong')
  }
}

export async function getAssessments(page, pageSize, search, category, languages) {
  const resp = await await getFeatureList('assessment', page)
  // const resp = await getDataWithParams('/external/feature/list?feature=assessment', {
  //   page: page,
  //   size: pageSize,
  //   search: search,
  //   category,
  // })
  if (resp.status === 200) {
    return {
      content: resp.data.map((assessment) => ({
        ...assessment,
        id: assessment.assessmentId,
      })),
      last: resp.data.length === 0,
      number: page,
      pageable: { pageSize: pageSize },
    }
  } else {
    toast.error('Something went wrong')
  }
}

export async function getArticles(page, pageSize, search, category, languages) {
  const resp = await getFeatureList('article', page)
  if (resp.status === 200) {
    return {
      content: resp.data.map((article) => ({
        ...article,
        id: article.assessmentId,
      })),
      last: resp.data.length === 0,
      number: page,
      pageable: { pageSize: pageSize },
    }
  } else {
    toast.error('Something went wrong')
  }
}

export async function getMentalStateTypes(page, pageSize, search, category, languages) {
  const resp = await getMentalStateTypeList(page)
  if (resp.status === 200) {
    return {
      content: resp.data.map((mentalStateType) => ({
        ...mentalStateType,
        id: mentalStateType.assessmentId,
      })),
      last: resp.data.length === 0,
      number: page,
      pageable: { pageSize: pageSize },
    }
  } else {
    toast.error('Something went wrong')
  }
}

export async function getTechniques(page, pageSize, search, category, languages) {
  const resp = await getDataWithParams(`/api/secure/technique/paginated/list/searchable`, {
    page: page,
    size: pageSize,
    search: search,
    category,
  })
  if (resp.status === 200) {
    return {
      content: resp.data.map((technique) => ({
        ...technique,
      })),
      last: resp.data.length === 0,
      number: page,
      pageable: { pageSize: pageSize },
    }
  } else {
    toast.error('Something went wrong')
  }
}

export async function GetRestData(
  page,
  pageSize,
  search,
  category,
  languages,
  mentorIds,
  searchType,
) {
  const resp = await getDataWithParams(`/api/secure/teacher/search/rest`, {
    page: page,
    pageSize,
    search: search,
    category,
    mentorIds,
    searchType: searchType,
  })
  if (resp.status === 200) {
    return {
      ...resp.data,
    }
  } else {
    toast.error('Something went wrong')
  }
}

export async function saveActivtyPlan(activityPlanObject, loadingTst) {
  // console.log({ saving: activityPlanObject })
  const resp = await postMPDataWithParams(
    '/api/secure/teacher/activity-plan/save',
    activityPlanObject,
    {},
    loadingTst,
  )
  if (resp.status === 200 && isCommonResponseSuccessful(resp?.data?.code)) {
    return resp
  }
  return null
}

export async function fetchAvailablePhases() {
  return []
}

export async function fetchAvailableActivities() {
  return []
}

export async function fetchSingleActivity(activityId, mentorId) {
  const resp = await getMPDataWithParams('/api/secure/teacher/activity/summary', {
    mentorId: mentorId,
    activityIds: activityId,
    summaryOnly: false,
  })
  if (resp.status === 200) {
    return resp.data?.[0]
  }
  return {}
}

export async function fetchSinglePhaseItem(phaseId) {
  return {}
}

export async function fetchListOfPhases() {
  return []
}

export async function fetchListOfActivities(page, search, mentorId = null) {
  const resp = await getMPDataWithParams('/api/secure/teacher/activity/summary', {
    page,
    mentorId: mentorId,
    search,
    size: 20,
  })
  if (resp.status === 200) {
    return {
      content: resp.data,
      last: resp.data.length === 0,
      number: page,
    }
  }
  return {
    content: [],
    last: true,
    number: page,
    pageable: {
      size: 20,
    },
  }
}

export function returnLoadOptions(optionsData) {
  return {
    options: optionsData?.content,
    hasMore: !optionsData.last,
    additional: {
      page: optionsData.number + 1,
      size: optionsData?.pageable?.pageSize || 10,
    },
  }
}

export async function getActivityObject(activityData, categoryId, store, mentorIds) {
  const convertedActivityIdObject = {
    itemId: activityData?.activityId,
    customFields: activityData?.customFields,
    type: categoryToDailyPlayType(categoryId, store),
  }

  console.log({ convertedActivityIdObject })
  const dpCardFoundObject = await getAndSetActivityTitle(convertedActivityIdObject, mentorIds)
  return {
    ...dpCardFoundObject.extraItem,
    value: activityData?.activityId,
    label: dpCardFoundObject.title || activityData?.activityId,
  }
}

async function getAndSetActivityTitle(card, mentorIDs) {
  let titleToReturn = card?.title
  let extraItem
  if (!card?.title && card?.itemId !== '') {
    switch (card.type) {
      case 'course':
        const sessionId = card.itemId
        const courseId = card?.customFields?.courseId

        const courseResponse = await getCourseData(courseId)
        const foundCourseSessionsArray = courseResponse?.data?.course?.sessions
        const foundEpisode = foundCourseSessionsArray?.find((courseSess) => {
          if (checkIfStringIsValid(courseId)) {
            console.log({
              sessionsSessId: courseSess?.sessionId,
              sessionId,
              selectedCourseId: courseId,
              courseSessCourseId: courseSess?.courseId,
            })
            return courseSess?.sessionId === sessionId
          } else {
            return true
          }
        })
        const teacherData = courseResponse.data.teacher
        // titleToReturn = `${foundCourse?.title}`
        titleToReturn = `${teacherData?.name} - ${foundEpisode?.title}`
        break
      case 'quote':
        const quoteResponse = await getQuoteData(card.itemId, false)
        if (quoteResponse.status === 200) {
          titleToReturn = `${quoteResponse.data.author} - ${quoteResponse.data.msg}`
          extraItem = quoteResponse.data
        }
        break
      // case 'breathe':
      //   const breatheResponse = await GetFeatureData(FEATURES_API.breathe.getSingle.url, {
      //     id: card.itemId,
      //   })
      //   if (breatheResponse.status === 200) {
      //     const foundBreathe = breatheResponse.data
      //     titleToReturn = foundBreathe?.name
      //     extraItem = foundBreathe
      //   }
      //   break

      //BREATH WORKS NEEDED
      //PRACTICE NEEDED
      case 'journal':
        const journalResponse = await getFeatureItemBySlug('journal', card.itemId, false)
        if (journalResponse.status === 200) {
          const journalData = journalResponse.data.data.journal
          titleToReturn = `${journalData.title}`
          extraItem = journalData
        }
        break
      case 'assessment':
        const assessmentResponse = await getFeatureItemBySlug('assessment', card.itemId, false)
        if (assessmentResponse.status === 200) {
          const assessmentData = assessmentResponse.data.data.assessment
          titleToReturn = `${assessmentData.title}`
          extraItem = assessmentData
        }
        break
      case 'article':
        const articleResponse = await getArticleById(card.itemId, false)
        if (articleResponse.status === 200) {
          titleToReturn = `${articleResponse.data.title}`
          extraItem = articleResponse.data
        }
        break
      case 'technique':
        const techniqueResponse = await getSingleTechnique(card.itemId, false)
        if (techniqueResponse.status === 200) {
          titleToReturn = `${techniqueResponse.data.title}`
          extraItem = techniqueResponse.data
        }
        break
      case 'mental-state-type':
        const mentalStateTypeResponse = await getMentalStateTypeById(card.itemId)
        if (mentalStateTypeResponse.status === 200) {
          titleToReturn = `${mentalStateTypeResponse.data.title}`
          extraItem = mentalStateTypeResponse.data
        }
        break
      case 'rest':
        const restResponse = await getRestDataById(card.itemId, { searchType: 'my' }, mentorIDs)
        if (restResponse.status === 200) {
          titleToReturn = `${restResponse.data.title}`
          extraItem = restResponse.data
        }
        break
      default:
        titleToReturn = 'Not Supported'
        extraItem = { title: titleToReturn }
        break
    }
  }
  console.log({ extraItem })
  return { ...card, title: titleToReturn, extraItem: extraItem || {} }
}
